export const DribbleIcon = () => {
  return (
    <svg
      width={18}
      height={19}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1702_81)">
        <path
          d="M0 9.5c0-1.632.402-3.138 1.206-4.518a8.936 8.936 0 013.276-3.276A8.816 8.816 0 019 .5c1.632 0 3.138.402 4.518 1.206a8.936 8.936 0 013.276 3.276A8.816 8.816 0 0118 9.5a8.816 8.816 0 01-1.206 4.518 8.936 8.936 0 01-3.276 3.276A8.816 8.816 0 019 18.5a8.816 8.816 0 01-4.518-1.206 8.936 8.936 0 01-3.276-3.276A8.816 8.816 0 010 9.5zm1.494 0c0 1.872.63 3.522 1.89 4.95.576-1.128 1.488-2.202 2.736-3.222 1.248-1.02 2.466-1.662 3.654-1.926-.18-.42-.354-.798-.522-1.134-2.064.66-4.296.99-6.696.99-.468 0-.816-.006-1.044-.018 0 .048-.003.108-.009.18a2.24 2.24 0 00-.009.18zm.234-1.854c.264.024.654.036 1.17.036 2.004 0 3.906-.27 5.706-.81-.912-1.62-1.914-2.97-3.006-4.05A7.307 7.307 0 003.159 4.82a7.685 7.685 0 00-1.431 2.826zm2.682 7.776c1.356 1.056 2.886 1.584 4.59 1.584.888 0 1.77-.168 2.646-.504a26.432 26.432 0 00-1.404-5.958c-1.104.24-2.217.846-3.339 1.818-1.122.972-1.953 1.992-2.493 3.06zM7.164 2.246C8.22 3.338 9.198 4.7 10.098 6.332c1.632-.684 2.862-1.554 3.69-2.61C12.396 2.57 10.8 1.994 9 1.994a6.91 6.91 0 00-1.836.252zm3.582 5.364c.18.384.384.87.612 1.458a30.89 30.89 0 012.898-.126c.744 0 1.482.018 2.214.054-.096-1.632-.684-3.084-1.764-4.356-.78 1.164-2.1 2.154-3.96 2.97zm1.062 2.718A25.836 25.836 0 0113.05 15.8a7.51 7.51 0 002.322-2.358c.6-.96.96-1.998 1.08-3.114-.876-.06-1.674-.09-2.394-.09-.66 0-1.41.03-2.25.09z"
          fill="#697484" // is changing to #fff by hover
        />
      </g>
      <defs>
        <clipPath id="clip0_1702_81">
          <path fill="#fff" transform="translate(0 .5)" d="M0 0H18V18H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}